const staticBalances = [10, 20, 50, 100, 150, 200];

export default staticBalances;
